import { DateTime, Duration } from "luxon";

export function date() {
  function getInternationalDate(value) {
    if (value) {
      return DateTime.fromISO(String(value)).toFormat(" yyyy-LL-dd HH:mm"); // adapte le format en international
    }
  }

  function libelleDuration(duration) {
    const durationLuxon = Duration.fromObject({
      seconds: duration,
      days: 0,
      hours: 0,
      minutes: 0,
      weeks: 0,
      months: 0,
      years: 0,
    })
      .normalize()
      .toObject();
    let durationString = "";

    if (durationLuxon.years >= 1) {
      durationString = durationLuxon.years + " an(s)";
    } else if (durationLuxon.months >= 1) {
      durationString = durationLuxon.months + " mois";
    } else if (durationLuxon.weeks >= 1) {
      durationString = durationLuxon.weeks + " semaine(s)";
    } else if (durationLuxon.days >= 1) {
      durationString = durationLuxon.days + " jour(s)";
    } else if (durationLuxon.hours >= 1) {
      durationString = durationLuxon.hours + " heure(s)";
    } else if (durationLuxon.minutes >= 1) {
      durationString = durationLuxon.minutes + " min(s)";
    }

    return durationString;
  }

  return {
    getInternationalDate,
    libelleDuration,
  };
}
